import { Injectable } from '@angular/core';
import { jwtDecode, JwtPayload } from 'jwt-decode';

import { Token } from '../interfaces/core/token.interface';

@Injectable()
export class TokenHandler {
  protected parseJWT(token: string): JwtPayload {
    return jwtDecode(token);
  }

  protected processTokens(token: string, tokenDecoded: JwtPayload): Token {
    const reduceTime = 0;
    if (!tokenDecoded.exp) {
      return {
        accessToken: '',
        expiresIn: 0,
      };
    }
    const expiresIn = tokenDecoded.exp - reduceTime;

    return {
      accessToken: token,
      expiresIn,
    };
  }

  protected checkTokenExpired(expiresIn = 0): boolean {
    const unixDate = Math.floor(Date.now() / 1000);
    const isExpired = expiresIn <= unixDate;

    return isExpired;
  }
}
